"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SearchConfigurationProvider = void 0;
var _react = require("react");
var _usePickupSearchConfigurationQuery = require("../api/usePickupSearchConfigurationQuery");
var _Loading = require("../components/Loading");
var _contexts = require("../contexts");
var _models = require("../models");
var _jsxRuntime = require("react/jsx-runtime");
const SearchConfigurationProvider = ({
  children,
  showFullScreenLoader
}) => {
  const mapMethods = (0, _react.useRef)(undefined);
  const {
    pickupSearchConfiguration: rawSearchConfig,
    isConfigurationLoading
  } = (0, _usePickupSearchConfigurationQuery.usePickupSearchConfigurationQuery)();
  const [viewSettings, setViewSettings] = (0, _react.useState)({
    location: {
      latitude: 0,
      longitude: 0
    },
    zoom: 0
  });
  // append exposed map methods to the pickup search configuration context data
  const pickupSearchConfiguration = rawSearchConfig ? {
    ...rawSearchConfig,
    mapMethods,
    viewSettings,
    setViewSettings
  } : undefined;
  if (isConfigurationLoading) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Loading.DialogLoadingOverlay, {
      id: _models.TestId.DialogLoadingOverlayPickupPointsDialogContent,
      isFullScreen: showFullScreenLoader
    });
  }
  return pickupSearchConfiguration ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_contexts.PickupPointsSearchConfigurationProvider, {
    value: pickupSearchConfiguration,
    children: children
  }) : null;
};
exports.SearchConfigurationProvider = SearchConfigurationProvider;